/** @flow */

export const hierarchyMessages = {
  en: {
    DRAFT_DISCARDED: "Draft Discarded",
    DRAFT_UPDATED: "Draft Updated",
    DEPARTMENT_ADDED: "Department was added",
    DEPARTMENT_MOVED: "Department was moved",
    DEPARTMENT_CUT: "Department was cut",
    DEPARTMENT_RENAMED: "Department was renamed",
    DEPARTMENT_DELETED: "Department was deleted",
    CONTACT_ADDED: "Contact was successfully added!",
    CONTACT_UPDATED: "Contact was successfully updated",
    SHIFT_PATTERN_ADDED: "Shift Pattern was successfully added",
    SHIFT_PATTERN_UPDATED: "Shift Pattern was successfully updated",
    CHANGE_REVERTED: "The change was reverted",
    HIERARCHY_DRAFT_PUBLISH_SUCCESS: "Hierarchy draft was successfully published",
  },
};

export default {
  en: {
    // Hierarchy Changes
    CHANGED_ON: "Changed On",
    ADD_DEPARTMENT: "Add Department",
    MOVE_DEPARTMENT: "Move Department",
    RENAME_DEPARTMENT: "Edit {name}",
    ORGANISATIONAL_UNIT: "Organisational Unit",
    DRAFT_HIERARCHY: "Draft Hierarchy",
    EDIT_NOTIFICATIONS_ADN_SHIFTS: "Edit Notifications & Shifts",
    ADD: "Add",
    CUT: "Cut",
    DELETE: "Delete",
    CREATE: "Create",
    MOVE: "Move",
    RENAME: "Rename",
    VIEW_SCOPE_CHANGES: "View Scope Changes",
    DISCARD: "Discard",
    CURRENT_HIERARCHY: "Current Hierarchy",
    PROVISIONAL_HIERARCHY: "Provisional Hierarchy",
    THERE_IS_CURRENTLY_NO_DRAFT_HIERARCHY: "No draft currently open",
    PUBLISHED_DATE: "Published On",
    PUBLISHED_BY: "Published By",
    FIND_DEPARTMENT: "Find department",
    LAST_UPDATED_ON: "Last Updated On",
    EXPORT_CURRENT_HIERARCHY: "Export Current",
    SIMPLE_EXPORT_HIERARCHY: "Simple Export",
    DETAILED_EXPORT: "Detailed Export",
    EXPORT_PROVISIONAL_HIERARCHY: "Export Provisional Hierarchy",
    CREATE_DRAFT_HIERARCHY: "Create Draft Hierarchy",
    START_DRAFT: "Start Draft",
    DRAFT_HISTORY: "Draft History",
    DRAFT_SUMMARY: "Draft Summary",
    CANCEL_DRAFT: "Cancel Draft",
    SAVE_AND_GO_BACK: "Save and Go Back",
    SAVE_DRAFT: "Save Draft",
    LAST_UPDATED: "Last Updated",
    UPDATED_BY: "Updated By",
    CONTINUE_EDITING: "Continue Editing",
    EDIT_DRAFT_HIERARCHY: "Edit Draft Hierarchy",
    CHANGES: "Changes",
    TOTAL_DEPARTMENTS: "Total Departments",
    CREATED: "Created",
    ADDED: "Added",
    MOVED: "Moved",
    TOTAL_CHANGES: "Total Changes",
    DELETE_DEPARTMENT: "Delete Department",
    DELETE_DEPARTMENT_WARNING: "Are you sure you want to delete this department?",
    DELETED: "Deleted",
    RENAMED: "Renamed",
    CHANGE_DESCRIPTION: "Change Description",
    CHANGED_AT: "Changed At",
    REVERT_CHANGES: "Revert Changes",
    REVERT_WARNING:
      "This change and all the ones preceding it will be undone: are you sure you want to proceed?",
    MOVE_BRANCH: "Move Branch",
    BRANCHES_TEXT: "Units",
    LEAFS_TEXT: "Employees in Unit",
    ADD_NEW_DEPARTMENT: "Add New Department",
    ACTION: "Action",
    SUBMIT_DRAFT: "Submit Draft",
    PUBLISH: "Publish",
    DELETION_WARNING: "Are you sure you want to cancel all change made to the most recent draft?",
    SUBMISSION_WARNING:
      "Are you sure you want to submit all changes made to your provisional hierarchy?",
    NON_SPACE_ERROR: "This field should contain at least a non-space character",
    SHIFT_PATTERNS: "Shift Patterns",
    NOTIFICATION_CONTACTS: "Notification Contacts",
    ADD_SHIFT_PATTERN: "Add Shift Pattern",
    DEPARTMENT_SCOPE: "Department Scope",
    SCOPE: "Scope",
    THIS_DEPARTMENT_ONLY: "This Department Only",
    THIS_DEPARTMENT_AND_CHILDREN: "This Department and its Children",
    BASIC_NOTIFICATION: "Basic notification",
    FULL_NOTIFICATION: "Full notification",
    SMS_ONLY_NOTIFICATION: "Sms only notification",
    STANDARD_NOTIFICATION: "Standard notification",
    NOTIFICATION_TYPE: "Notification Type",
    NOTIFICATION_CONTACT_HISTORY: "Notification Contact History",
    NOTIFICATION_SCOPES: "Notification Scopes",
    DATE_UPDATED: "Date Updated",
    SHIFT_PATTERN: "Shift Pattern",
    SHIFT_PATTERN_WITH_ID: "Shift Pattern - Absence #{id}",
    SUMMARY: "Summary",
    TOTAL_CONTACTS: "Total Contacts",
    CONTACTS_IN_DEPARTMENT: "Contacts In Department",
    INHERITED_CONTACTS: "Inherited Contacts",
    DEPARTMENT_REF: "Department Ref",
    EDIT_SHIFT_PATTERN: "Edit Shift Pattern",
    SELECT_SHIFT_PATTERN: "Select Shift Pattern",
    ADD_PATTERN: "Add Pattern",
    SELECT_CONTACT: "Select Contact",
    THIS_DEPARTMENT_AND_ITS_CHILDREN: "This Department and Its Children",
    CONFIGURE: "Configure",
    CONTACT: "Contact",
    EDIT_CONTACT: "Edit Contact",
    INHERITED_FROM: "Inherited from",
    COUNT_RECORD_SELECTED: "{count} record selected",
    COUNT_RECORD_SELECTED_plural: "{count} records selected",
    CONTACT_SUCCESSFUL_DELETED: "{count} notification contact was successful deleted!",
    CONTACT_SUCCESSFUL_DELETED_plural: "{count} notification contacts were successful deleted!",
    SHIFT_PATTERN_ASSIGNMENT_SUCCESSFUL_DELETED:
      "{count} shift pattern assignment was successfully deleted!",
    SHIFT_PATTERN_ASSIGNMENT_SUCCESSFUL_DELETED_plural:
      "{count} shift pattern assignments were successful deleted!",
    NEED_TO_MAKE_SOME_CHANGES: "Need to make some hierarchy changes?",

    // Notifications Contacts & Shifts
    HIERARCHY_NOTIFICATIONS: "Notifications & Shifts",
    HIERARCHY_NOTIFICATIONS_SHIFTS: "Notification Contacts & Shifts",
    DEPARTMENT_NOTIFICATION_CONTACTS: "Department Notification Contacts",
    DEPARTMENT_CONTACTS: "Department Contacts",

    // Hierarchy Change Log
    HIERARCHY_CHANGE_LOG: "Hierarchy Change Log",
    NO_CHANGES_USERS: "No Changes Were Made Yet",
    NO_CHANGES_FILTERS: "No Changes Matching the Filters Were Made Yet",
    DONE: "Done",

    HIERARCHY_ADMIN: "Hierarchy Admin",
    ORG_STRUCTURE: "Org Structure",
    EDIT_HIERARCHY: "Edit Hierarchy",
    HIERARCHY_CHANGES_DESCRIPTION: "View and edit the hierarchy.",
    HIERARCHY_NOTIFICATIONS_SHIFTS_DESCRIPTION:
      "Edit and add notification contacts and shift patterns.",
    HIERARCHY_NOTIFICATIONS_SHIFTS_VIEW: "View Notification Contacts & Shifts",
    HIERARCHY_CHANGE_LOG_DESCRIPTION: "View the change log for Hierarchy.",
    HIERARCHY_CHANGE_LOG_VIEW: "View Change Log",

    CHANGE_DATE: "Change Date",
    CHANGE_METHOD: "Change Method",
    CHANGE_TYPE: "Change Type",
    UPDATE_TYPE: "Update Type",
    USER: "User",
    DELETE_DEPARTMENT_CHILD_DEPARTMENTS_WARNING:
      "Do you wish to delete the child departments as well?",
    DELETE_DEPARTMENT_EMPLOYEES_WARNING:
      "The Department cannot be deleted until all employee records have been assigned to a new department.",
    DELETE_DEPARTMENT_CHILD_EMPLOYEES_WARNING:
      "One or more child departments have an employee record and must be moved to sit under another parent before this department can be deleted.",
  },
};
